import axios from "axios";
import React, { useState } from "react";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const Register = () => {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [email, setEmail] = useState("");
  const [showPassword, setShowPassword] = useState(false);

  const handleSignUp = async (e) => {
    e.preventDefault();

    // Trim to avoid leading/trailing spaces
    const trimmedUsername = username.trim();
    const trimmedEmail = email.trim();
    const trimmedPassword = password.trim();

    if (!trimmedUsername || !trimmedEmail || !trimmedPassword) {
      toast.error("All fields are required.");
      return;
    }

    if (trimmedPassword.length < 6) {
      toast.error("Password must be at least 6 characters.");
      return;
    }

    try {
      // If backend expects form-data
      const formData = new FormData();
      formData.append("login_name", trimmedUsername);
      formData.append("login_email", trimmedEmail);
      formData.append("login_password", trimmedPassword);

      const response = await axios.post(
        "https://cyberathon.com/silverapartment/index.php/Api/Silver_Controller/register",
        formData
      );

      console.log("Server Response:", response.data);

      if (response.data.success === 1) {
        toast.success(response.data.message || "Account created successfully!");
        setUsername("");
        setEmail("");
        setPassword("");
        setTimeout(() => {
          window.location.href = "/";
        }, 1000);
      } else {
        toast.error(response.data.message || "Error creating account.");
      }
    } catch (err) {
      console.error("Error:", err);
      toast.error(err.response?.data?.message || "Error creating account.");
    }
  };

  return (
    <div>
      <form className="form" onSubmit={handleSignUp}>
        <span className="signup">Register</span>

        <input
          type="text"
          onChange={(e) => setUsername(e.target.value)}
          value={username}
          placeholder="Name"
          className="form--input"
          autoComplete="name"
        />

        <input
          type="email"
          onChange={(e) => setEmail(e.target.value)}
          value={email}
          placeholder="Email address"
          className="form--input"
          autoComplete="email"
        />

        <div className="password-wrapper">
          <input
            required
            placeholder="Password"
            className="form--input"
            type={showPassword ? "text" : "password"}
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            autoComplete="new-password"
          />
          <button
            className="password-toggle"
            type="button"
            onClick={() => setShowPassword((prev) => !prev)}
          >
            <svg fill="none" viewBox="0 0 24 24" className="eye-icon">
              <path
                strokeWidth="1.5"
                stroke="currentColor"
                d="M2 12S5 5 12 5s10 7 10 7-3 7-10 7S2 12 2 12Z"
              />
              <circle
                strokeWidth="1.5"
                stroke="currentColor"
                r={3}
                cy={12}
                cx={12}
              />
            </svg>
          </button>
        </div>

        <button type="submit" className="form--submit">
          Register
        </button>

        <div className="form-footer">
          <a className="login-link" href="/">
            Already have an account? <span>Login</span>
          </a>
        </div>
      </form>

      <ToastContainer />
    </div>
  );
};

export default Register;

